import { formatString, toPlural } from './global-functions'
/**
 * Initializes global augmentations for Array and String prototypes.
 *
 * Adds the following methods:
 * - Array.prototype.addOrUpdate: Adds or updates an element in an array based on a predicate
 * - Array.prototype.update: Updates an element in an array based on a predicate
 * - String.prototype.gs_format: Formats a string using the formatString utility
 *
 * These augmentations must be initialized by calling this function before they can be used.
 */

export function initializeGlobalAugmentation() {
  Array.prototype.addOrUpdate = function (this, elm, predicate) {
    if (Array.isArray(this) && this.length > 0) {
      const idx = this.findIndex(predicate)
      if (idx >= 0) {
        this.splice(idx, 1, elm)
      } else {
        this.push(elm)
      }
    }
    return this
  }

  Array.prototype.update = function (this, elm, predicate) {
    if (Array.isArray(this) && this.length > 0) {
      const idx = this.findIndex(predicate)
      if (idx >= 0) {
        this.splice(idx, 1, elm)
      }
    }
    return this
  }

  String.prototype.gs_format = function (this, format, formatOptions) {
    return formatString(this, format, formatOptions)
  }

  String.prototype.gs_toPlural = function (
    this,
    count,
    pluralText,
    removeLastLetter
  ) {
    return (
      toPlural(this ?? '', count, pluralText, removeLastLetter) ?? this ?? ''
    )
  }
}
